import type { PostHogConfig } from 'posthog-js';
import { PostHogProvider, usePostHog } from 'posthog-js/react';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const options: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  capture_pageview: false,
  session_recording: {
    maskTextSelector: '.sensitive-text',
  },
}

function Wrapper({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.capture(
      '$pageview',
      {
        '$current_url': window.location.href,
      }
    );
  }, [location, posthog]);

  return children;
}

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  if (!import.meta.env.VITE_POSTHOG_API_KEY) {
    return <>{children}</>;
  }

  return <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_API_KEY}
      options={options}
    >
      <Wrapper>{children}</Wrapper>
    </PostHogProvider>;
}
